import { type FC } from "react";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import TableCellText from "./core/TableCellText.js";

const BlastSequenceCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value || !props.data) {
    return null;
  }

  let value = props.value;
  if (Array.isArray(props.value)) {
    // assume props.data.groupType === 'blastHit' // and props.colDef.field === 'bestHsp.relatedGenes.sequence'
    if (props.value.length === 1) {
      value = props.value[0];
    } else if (props.value.length >= 1) {
      value = value.length + " sequences";
    }
  }

  return <TableCellText {...props} tooltip={value} classname={"seq-residue"} />;
};

export default BlastSequenceCell;
